import { __decorate } from "tslib";
import { Component } from 'decorators';
import template from './ReadOnlyPromptItem.view.html';
import { ROLE_ICON_MAP } from '../../../../../../utils/promptUtils';
let ReadOnlyPromptItemComponent = class ReadOnlyPromptItemComponent {
    constructor() {
        this.roleIconMap = ROLE_ICON_MAP;
    }
};
ReadOnlyPromptItemComponent = __decorate([
    Component({
        controllerAs: '$ctrl',
        bindings: {
            prompt: '<',
        },
        template,
    })
], ReadOnlyPromptItemComponent);
export { ReadOnlyPromptItemComponent };
